import { Tooltip } from '@mantine/core';

import classes from './Tooltip.module.css';

// // If you have an element that is not compatible, you can use the forwardRef
// const Wrapper = forwardRef<HTMLDivElement, React.ComponentPropsWithoutRef<'div'>>((props, ref) => (
//   <div ref={ref} {...props}>
//     {props.children}
//   </div>
// ));

// Wrapper.displayName = 'TooltipWrapper';
//  const Tooltip = ({ label, children, color, wrap, ...props }: TooltipProps) => {
//   return (
//     <MantineTooltip label={label} color={color} {...props}>
//       {wrap ? <Wrapper>{children}</Wrapper> : children}
//     </MantineTooltip>
//   );
// };

const TooltipDefaults = Tooltip.extend({
  classNames: {
    tooltip: classes.tooltip,
  },
  defaultProps: {
    multiline: true,
    withArrow: true,
    arrowSize: 8,
    transitionProps: { transition: 'fade', duration: 200 },
    color: 'slate',
    radius: 'sm',
    position: 'top',
    events: { hover: true, focus: false, touch: true },
  },
});

export { Tooltip, TooltipDefaults };
